import React from 'react';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { IncludedSection } from '../components/IncludedSection';
import { PricingSection } from '../components/PricingSection';
import { FAQSection } from '../components/FAQSection';
import { Footer } from '../components/Footer';
import { Button } from '../components/Button';
import { motion } from 'framer-motion';
export function LandingPage() {
  return <main className="w-full min-h-screen bg-white" data-id="element-218">
      <Hero data-id="element-219" />
      <ProblemSection data-id="element-220" />
      <SolutionSection data-id="element-221" />
      <IncludedSection data-id="element-222" />
      <PricingSection data-id="element-223" />
      <FAQSection data-id="element-224" />

      {/* Final CTA Section */}
      <section className="w-full bg-[#7B9FAB] py-20 md:py-32 px-4" data-id="element-225">
        <div className="max-w-4xl mx-auto text-center" data-id="element-226">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} className="space-y-8" data-id="element-227">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif text-white leading-tight" data-id="element-228">
              Pon el timer. Elige la zona. Haz la misión.
            </h2>
            <p className="text-2xl text-white/90" data-id="element-229">15 minutos. Y se nota.</p>
            <div className="pt-4" data-id="element-230">
              <Button onClick={() => {
              const pricingSection = document.getElementById('pricing');
              pricingSection?.scrollIntoView({
                behavior: 'smooth'
              });
            }} className="bg-[#C17B6B] hover:bg-[#B06A5A] text-white text-xl px-12 py-5" data-id="element-231">
                Comenzar ahora
              </Button>
            </div>
          </motion.div>
        </div>
      </section>

      <Footer data-id="element-232" />
    </main>;
}